/**
 * Feature gating utility — checks user tier to gate features by subscription.
 */

const FEATURE_TIERS = {
  "all_predictions_4": ["pro", "pro_plus", "pro_max"],
  "all_predictions_6": ["pro_plus", "pro_max"],
  "all_predictions_8": ["pro_max"],
  "extended_lock": ["pro_plus", "pro_max"],
  "captain_change": ["pro_max"],
  "extra_budget_2": ["pro_plus"],
  "extra_budget_5": ["pro_max"],
  "predictor_multiplier_125": ["pro_plus"],
  "predictor_multiplier_150": ["pro_max"],
  "unlimited_player_stats": ["pro_max"],
};

export function hasFeature(user, featureName) {
  if (!user) return false;
  const tier = getEffectiveTier(user);
  if (tier === "free") return false;
  return (FEATURE_TIERS[featureName] || []).includes(tier);
}

export function getEffectiveTier(user) {
  if (!user) return "free";
  const tier = user.tier || "free";
  if (tier === "free") return "free";
  const expires = user.tier_expires_at;
  if (expires && new Date(expires) < new Date()) return "free";
  return tier;
}

export function getTierLabel(tier) {
  const labels = {
    free: "Free",
    pro: "Pro",
    pro_plus: "Pro Plus",
    pro_max: "Pro Max",
  };
  return labels[tier] || "Free";
}

export function getFreePredictionLimit(tier) {
  const limits = { free: 3, pro: 4, pro_plus: 6, pro_max: 8 };
  return limits[tier] || 2;
}

export { FEATURE_TIERS };
